<template>
    <div class="col-12">
        <div  class="searchBar-top">
          <input @keyup.enter="serach" v-model="serachString" :class="{'border-none':hideBorder}" id="searchQueryInput-top" type="text" name="searchQueryInput" :placeholder="placeHolderText" />
          <button @click="serach" id="searchQuerySubmit" type="submit" name="searchQuerySubmit">
            <i class="fa fa-search" aria-hidden="true"></i>
          </button>
        </div>
        <ul v-if="serachResult" class="ml-2 position-absolute list-group serachResult serachResult-md">
          <router-link @click="clearSearch" :to="item.link" v-for="(item, index) in serachResult" :key="index" role="button" class="list-group-item list-group-item-action"><span class="font-weight-bold">{{ item.typeString }}</span> : {{ item.description }}</router-link>
        </ul>
    </div>
</template>
  
<script>
import _ from 'lodash'
import SearchService from '../../services/search.service'

export default {
  name: 'GlobalSearch',
  data() {
    return {
      serachString: '',
      serachResult: []
    }
  },
  watch: {
    serachString: _.debounce(function () { this.serach() }, 1000),
    '$store.getters.getSearchString': function() {
      if(this.$store.getters.getSearchString) {
        this.serachString = this.$store.getters.getSearchString
      }
    }
  },
  computed: {
    hideBorder() {
      return this.$route.path.includes('home')
    },
    placeHolderText() {
      if (this.$route.path.includes('home')) {
        return 'Type to search'
      } else {
        return 'Search'
      }
    }
  },
  mounted() {
    if(this.$store.getters.getSearchString) {
      this.serachString = this.$store.getters.getSearchString
    }
  },
  methods: {
    serach(){
      if(this.serachString) {
        SearchService.getSerachResult(this.serachString).then(response => {
          if(response.data.Object.Data.length > 0) {
            this.serachResult = response.data.Object.Data
          } else  {
            this.serachResult = []
          }
          this.processSearchResult()
        }),
        error => {
          console.log(error)
        }
      } else {
        this.serachResult = []
      }
    },
    processSearchResult () {
      var vm = this
      _.forEach(vm.serachResult, function(item) {
        item.metaList = item.ObjectMetadata.split('|').map(item=>item.trim())
        if(item.Type === 0) {
          // Store
        } else if (item.Type === 1) {
          // Faq
          item.link = '/faq/'+ item.metaList[0] +'/'+item.ObjectId
          item.typeString = 'FAQ'
          item.description = vm.truncateString(item.metaList[2])
        } else if (item.Type === 2) {
          // Release Notes
          item.link = '/release/'+ item.ObjectId
          item.typeString = 'Release'
          item.description = vm.truncateString(item.metaList[0])
        } else if (item.Type === 3) {
          // Blog
          item.link = '/blog/'+ item.ObjectId
          item.typeString = 'Blog'
          item.description = vm.truncateString(item.metaList[0])
        } else if (item.Type === 4) {
          // NewsAndPress
          item.link = '/news/' + item.ObjectId
          item.typeString = 'News'
          item.description = vm.truncateString(item.metaList[0])
        }
      })
    },
    clearSearch () {
      this.serachString = ''
      this.$store.dispatch('chnageSearchString', '')
    },
    truncateString (String) {
      return String.substring(0, 47) + (String.length > 50 ? '...' : '')
    }
  },
}
</script>
  